module.exports = __webpack_public_path__ + "img/no_user_photo.71bf26d5.svg";